import React, { Fragment } from 'react';
import { Row, Col } from 'antd';
import TextBox from 'theme/TextBox';
import Form from 'theme/Form';
import Error from 'theme/Error';
import Countdown from './Countdown';

const $STA = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/auth`);

class SmsVerificationModal extends Form {
  state = { isSmsExpired: false, formData: { code: null } };

  finishHandler = () => this.setState({ isSmsExpired: true });

  render() {
    const {
      isSmsExpired,
      formData: { code },
    } = this.state;
    const { error = {}, onEnter, expire } = this.props;

    return (
      <div className='smsVerificationContainer'>
        <Fragment>
          <Row>
            <Col className='text-center title'>
              <h4>{$STA.SMS_VERIFICATION.TITLE}</h4>
            </Col>
          </Row>
          <Row>
            <Col className='text-center description'>
              <p>{$STA.SMS_VERIFICATION.DESCRIPTION}</p>
            </Col>
          </Row>
          {expire && (
            <Row>
              <Col
                className={`text-center countdown ${isSmsExpired && 'finish'}`}
              >
                <Countdown
                  prefix='sms'
                  endDate={expire}
                  format='mm:ss'
                  onFinish={this.finishHandler}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col className='input'>
              <TextBox
                name='verification_code'
                type='text'
                classes='text-center'
                placeholder={$STA.SMS_VERIFICATION.PLACEHOLDER}
                onChange={(value) =>
                  this.setField('code', value.replace(/\D+/g, ''))
                }
                value={code}
              />
              <Error data={error} field='code' />
              <Error data={error} field='api_error' />
            </Col>
          </Row>
          <Row>
            <Col className='action'>
              <button
                onClick={() => onEnter(code)}
                className='button pointer sendButton'
                disabled={!code || isSmsExpired}
              >
                {$STA.SMS_VERIFICATION.SEND_BUTTON_TEXT}
              </button>
            </Col>
          </Row>
        </Fragment>
      </div>
    );
  }
}

export default SmsVerificationModal;



// WEBPACK FOOTER //
// ./src/components/partials/SmsVerificationModal.js